import useMarket from 'hook/useMarket';
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getDetailStock } from 'store/actionReducers/TrendStore';
import SearchInput from './SearchInput'
import './TabFilter.scss'
import iconBack from '../../../../../assets/images/StockAnalysis/icon-back.png'

export default function TabFilter(props) {
  const dispatch = useDispatch();
  const TrendStore = useSelector((state) => state?.TrendStore);
  // const tabActive = TrendStore?.tabFilter
  const [tabActive, setTabActive] = useState('')

  useEffect(() => {
    if (props.tabActiveDefault) {
      setTabActive(props.tabActiveDefault)
    }
  }, [props.tabActiveDefault])

  const handleChangeTab = (tab) => {
    if (props?.clickFilter) {
      setTabActive(tab)
      props?.clickFilter(tab)
    }
  }

  const handleBack = () => {
    dispatch(getDetailStock({ step: TrendStore?.stepHistory, data: {} }))
  }

  return (
    <>
      <div className='sswaqppore'>
        <div onClick={() => handleChangeTab('increase')} className={`sifuopmowk ${tabActive === 'increase' ? 'udFEiEDtgR' : ''}`}>Tăng mạnh</div>
        <div onClick={() => handleChangeTab('weaken')} className={`sifuopmowk ${tabActive === 'weaken' ? 'udFEiEDtgR' : ''}`}>Suy yếu</div>
        <div onClick={() => handleChangeTab('plummeted')} className={`sifuopmowk ${tabActive === 'plummeted' ? 'udFEiEDtgR' : ''}`}>Giảm mạnh</div>
        <div onClick={() => handleChangeTab('recuperate')} className={`sifuopmowk ${tabActive === 'recuperate' ? 'udFEiEDtgR' : ''}`}>Hồi phục</div>
        <div onClick={() => handleChangeTab('all')} className={`sifuopmowk ${tabActive === 'all' ? 'udFEiEDtgR' : ''}`}>Tất cả</div>
        <div className='ssfjpzwaik'>
          <SearchInput hiddenMobile={true} />
        </div>
        {
          TrendStore?.step === 'branch' ? <>
            <div className='klPybDJriH' onClick={() => handleBack()}><img src={iconBack} alt='' className='SaKCuJJtHX' /></div>
          </> : null
        }
        {
          TrendStore?.step === 'code' ? <>
            <div className='klPybDJriH' onClick={() => handleBack()}><img src={iconBack} alt='' className='SaKCuJJtHX' /></div>
          </> : null
        }
      </div>
    </>
  )
}